import { DASFBinder } from "../../data/dasf/DASFBinder.js";
import { DASFForm } from "../../data/dasf/DASFForm.js";

/**
 * A function that creates the DASF loader form
 * 
 * @memberof vef.viewer.loader
 * 
 * @param {object} options 
 * @param {Viewer} viewer 
 */
export function DASFLoader(options, viewer) {
    const element = new DASFForm(null, options);
    const binder = new DASFBinder();

    element.on("invalid", e => console.log(e));
    element.on("submit", data => console.log(data));

    viewer.addElement(options.id, element);
}